import type { LibraryClientsEditModel } from '@efdigital/ll-admin-v2/routes/library/clients/client';
import { on } from '@ember/modifier';
import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class LibraryClientsClientEdit extends Component<{
  Args: {
    model: LibraryClientsEditModel;
  };
}> {
  @tracked isMobileMenuOpen = false;

  toggleMobileMenu = () => {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  };

  <template>
    <div class="container py-4">
      <div class="mb-4 d-flex align-items-center justify-content-between">
        <LinkTo
          @route="library.clients.index"
          class="btn btn-sm btn-outline-secondary"
        >
          <iconify-icon inline icon="ph:arrow-left" />
          Back to Client Library
        </LinkTo>

        {{! Mobile Menu Toggle }}
        <button
          type="button"
          class="btn btn-outline-primary d-md-none"
          {{on "click" this.toggleMobileMenu}}
          aria-label="Toggle navigation menu"
        >
          <iconify-icon inline icon="ph:list" />
          Menu
        </button>
      </div>

      <div class="row">
        {{! Sidebar Navigation }}
        <div class="col-md-4 col-lg-3 mb-4 mb-md-0">
          <div class="card {{if this.isMobileMenuOpen '' 'd-none d-md-block'}}">
            <div
              class="card-header bg-white d-flex align-items-center justify-content-between"
            >
              <div>
                <h5 class="mb-0">{{@model.client.title}}</h5>
                <small class="text-muted">Client Management</small>
              </div>
              <button
                type="button"
                class="btn-close d-md-none"
                {{on "click" this.toggleMobileMenu}}
                aria-label="Close menu"
              ></button>
            </div>
            <div class="list-group list-group-flush">
              <LinkTo
                @route="library.clients.client.edit.general"
                class="list-group-item list-group-item-action"
              >
                <iconify-icon inline icon="ph:identification-card" />
                Subscription
              </LinkTo>
              <LinkTo
                @route="library.clients.client.edit.branding"
                class="list-group-item list-group-item-action"
              >
                <iconify-icon inline icon="ph:palette" />
                Branding
              </LinkTo>
              <LinkTo
                @route="library.clients.client.edit.home"
                class="list-group-item list-group-item-action"
              >
                <iconify-icon inline icon="ph:browser-duotone" />
                Leadership Live
              </LinkTo>
              <LinkTo
                @route="library.clients.client.edit.users"
                class="list-group-item list-group-item-action"
              >
                <iconify-icon inline icon="ph:users" />
                Users &amp; Access
              </LinkTo>
              <LinkTo
                @route="library.clients.client.edit.lti-integrations"
                class="list-group-item list-group-item-action"
              >
                <iconify-icon inline icon="ph:plug" />
                LTI Integration
              </LinkTo>
              <LinkTo
                @route="library.clients.client.edit.xapi"
                class="list-group-item list-group-item-action"
              >
                <iconify-icon inline icon="ph:graduation-cap" />
                Learning Record Store
              </LinkTo>
              <LinkTo
                @route="library.clients.client.edit.files"
                class="list-group-item list-group-item-action"
              >
                <iconify-icon inline icon="ph:folder" />
                Private Files
              </LinkTo>
            </div>
          </div>
        </div>

        {{! Main Content Area }}
        <div class="col-md-8 col-lg-9">
          {{outlet}}
        </div>
      </div>
    </div>
  </template>
}
